<template>
  <!-- 自定义弹框组件 -->
  <div class="mypopup-container" v-if="show">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['show'],
  created () {
  },
  watch: {
    show: {
      immediate: true,
      handler: function () {
        if (this.show) {
          document.documentElement.style.overflowY = 'hidden'
        } else {
          document.documentElement.style.overflowY = 'auto'
        }
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.mypopup-container{
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0,0.6);
  z-index: 2002;
}
</style>



// WEBPACK FOOTER //
// src/components/Public/MyPopup.vue